/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { Tag } from 'primereact/tag'
import { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { useSelector } from 'react-redux'
import UpsertPopup from '../../components/form/UpsertPopup'
import Table from '../../components/layout/Table'
import chungNhanTotNghiepTamThoiProcessor from '../../processor/chungNhanTotNghiepTamThoiProcessor'
import truongProcessor from '../../processor/truongProcessor'
import trangThaiCapPhat, {
  getTrangThaiCapPhat,
  trangThaiCapPhats,
} from '../../constant/trangThaiCapPhat'
import CapPhat from './CapPhat'
import tempChungNhan from './tempChungNhan'

const gioiTinh = [
  { name: 'Nam', id: 1 },
  { name: 'Nữ', id: 2 },
  { name: 'Khác', id: 3 },
]
const config = {
  fields: [
    'truongId',
    'lop',
    'tenHocSinh',
    'gioiTinh',
    'ngaySinh',
    'noiSinh',
    'noiCuTru',
    'ngayTotNghiep',
    'xepLoai',
    'tinhThanhPho',
    'hieuTruong',
    'lyDo',
  ],
  types: { truongId: 'select', gioiTinh: 'select', ngaySinh: 'date', ngayTotNghiep: 'date' },
  options: { gioiTinh },
  maxLength: {
    lop: 20,
    tenHocSinh: 50,
    noiSinh: 80,
    noiCuTru: 80,
    xepLoai: 20,
    tinhThanhPho: 80,
  },
  required: ['truongId'],
  name: {
    truongId: 'Trường',
    lop: 'Lớp',
    tenHocSinh: 'Tên học sinh',
    gioiTinh: 'Giới tính',
    ngaySinh: 'Ngày sinh',
    noiSinh: 'Nơi sinh',
    noiCuTru: 'Nơi cư trú',
    ngayTotNghiep: 'Ngày tốt nghiệp',
    xepLoai: 'Xếp loại',
    tinhThanhPho: 'Tỉnh thành phố',
    hieuTruong: 'Hiệu trưởng',
    lyDo: 'Lý do',
  },
}

function ChungNhanTotNghiepTamThoi() {
  const moduleName = 'chứng nhận tốt nghiệp tạm thời'
  const processor = chungNhanTotNghiepTamThoiProcessor
  const [truong, setTruong] = useState([])
  const [selectedTruong, setSelectedTruong] = useState(0)
  const [selectedGioiTinh, setSelectedGioiTinh] = useState(0)
  const [selectedTrangThaiCapPhat, setSelectedTrangThaiCapPhat] = useState(0)
  const [name, setName] = useState('')
  const [paging, setPaging] = useState({ skip: 0, take: 10, total: 0 })
  const userDonVi = useSelector((item) => item.user.info.donVi)

  config.options.truongId = truong
  const column = [
    { value: 'tenHocSinh', name: 'Họ tên', sortable: true },
    { value: 'ngaySinh', name: 'Ngày sinh', sortable: true },
    {
      value: 'truongId',
      name: 'Trường',
      render: (data) => {
        const trg = truong.find((item) => item.id === data.truongId)
        return trg ? trg.name : ''
      },
    },
    {
      value: 'trangThai',
      name: 'Trạng thái cấp phát',
      render: (data) => {
        return (
          <Tag
            severity={data.trangThaiCapPhat === 1 ? 'success' : 'danger'}
            value={getTrangThaiCapPhat(data.trangThaiCapPhat)}
          />
        )
      },
    },
  ]

  const [oneData, setOneData] = useState({})
  const [datas, setDatas] = useState([])
  const [visible, setVisible] = useState(false)
  const toast = useSelector((store) => store.notify.toast)
  const confirm = useSelector((store) => store.notify.confirm)
  const toggle = () => setVisible(!visible)

  const getDatas = async () => {
    const rs = await processor.getAll({
      name,
      truongId: selectedTruong,
      gioiTinh: selectedGioiTinh,
      trangThai: selectedTrangThaiCapPhat,
      skip: paging.skip,
      take: paging.take,
    })
    setDatas(rs.values)
    setPaging({ ...paging, total: rs.totalItemsCount })
  }
  const pagingChange = async (e) => {
    if (paging.skip !== e.first) {
      const rs = await processor.getAll({
        name,
        truongId: selectedTruong,
        gioiTinh: selectedGioiTinh,
        trangThai: selectedTrangThaiCapPhat,
        skip: e.first,
        take: paging.take,
      })
      setDatas(rs.values)
      setPaging({ ...paging, skip: e.first })
    }
    if (paging.take !== e.rows) {
      const rs = await processor.getAll({
        name,
        truongId: selectedTruong,
        gioiTinh: selectedGioiTinh,
        trangThai: selectedTrangThaiCapPhat,
        skip: paging.skip,
        take: e.rows,
      })
      setDatas(rs.values)
      setPaging({ ...paging, take: e.rows })
    }
  }
  const init = async () => {
    const rs = await truongProcessor.getAll()
    setTruong(rs)
  }
  useEffect(init, [])
  useEffect(getDatas, [selectedTruong, selectedGioiTinh, selectedTrangThaiCapPhat, name])

  const save = async (data) => {
    const rs = await processor.upsert(data)
    let message = rs.data
    let newData
    if (rs.isSuccess) {
      if (!data.id) {
        message = 'Thêm mới thành công'
      }
      setDatas(newData)
    }
    getDatas()
    toggle()
    toast({ type: rs.isSuccess ? 'success' : 'error', message })
  }
  const deleteOnClick = async (id) => {
    const rs = await processor.delete(id)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) setDatas([...datas.filter((item) => item.id !== id)])
  }
  const capPhat = async (data, addition) => {
    const rs = await processor.upsert({
      ...data,
      ...addition,
      trangThaiCapPhat: trangThaiCapPhat.daCapPhat,
    })
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) getDatas()
  }
  const columnTable = [
    ...column,
    {
      name: 'Chức năng',
      alignHeader: 'center',
      render: (data) => {
        return (
          <div className="flex justify-content-center">
            {data.trangThaiCapPhat === trangThaiCapPhat.chuaCapPhat && (
              <CapPhat data={data} submit={capPhat} />
            )}
            {data.trangThaiCapPhat === trangThaiCapPhat.daCapPhat && (
              <Button
                icon="pi pi-print"
                className="p-button-rounded p-button-success mr-2"
                onClick={() => {
                  const windowPrint = window.open('', 'PRINT', 'height=500,width=1200')
                  windowPrint.document.write(
                    tempChungNhan({
                      ...data,
                      truong: truong.find((item) => item.id === data.truongId) || {},
                      donVi: userDonVi,
                    }),
                  )
                  windowPrint.document.close()
                  windowPrint.focus()
                }}
                tooltip="In"
                tooltipOptions={{ position: 'top' }}
              />
            )}
            <Button
              icon="pi pi-pencil"
              className="p-button-rounded p-button-warning mr-2"
              onClick={() => {
                setOneData(data)
                toggle()
              }}
              tooltip="Sửa"
              tooltipOptions={{ position: 'top' }}
            />
            <Button
              icon="pi pi-trash"
              className="p-button-rounded p-button-danger mr-2"
              onClick={() => {
                confirm({
                  action: () => deleteOnClick(data.id),
                  body: `Bạn có muốn xoá ${moduleName} này?`,
                })
              }}
              tooltip="Xoá"
              tooltipOptions={{ position: 'top' }}
            />
          </div>
        )
      },
    },
  ]

  const tableHeader = `Danh sách ${moduleName}`
  const header = !oneData.id ? `Thêm mới ${moduleName}` : `Chỉnh sửa ${moduleName}`

  const configUpsert = {}
  Object.keys(config).forEach((key) => {
    const item = config[key]
    configUpsert[key] = typeof item === 'function' ? item(oneData) : item
  })
  return (
    <>
      <UpsertPopup
        width="60%"
        visible={visible}
        toggle={toggle}
        header={header}
        data={oneData}
        onSave={save}
        {...configUpsert}
      />
      <div className="flex flex-column">
        <div className="flex justify-content-between">
          <h4>Danh sách chứng nhận tốt nghiệp tạm thời</h4>
          <div>
            <Button
              icon="pi pi-plus"
              className="p-button-success"
              label="Thêm"
              onClick={() => {
                setOneData({})
                toggle()
              }}
            />
          </div>
        </div>
        <div className="card">
          <Toolbar
            className="mb-4"
            right={
              <div className="flex">
                <div className="flex vanbang-seacher-cotainer">
                  <div className="flex">
                    <InputText
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="mr-2 mb-2"
                      placeholder="Tên học sinh"
                    />
                  </div>
                  <div className="flex">
                    <Dropdown
                      className="mr-2 mb-2 w-full"
                      value={selectedTrangThaiCapPhat}
                      onChange={(e) => setSelectedTrangThaiCapPhat(e.value)}
                      optionValue="id"
                      optionLabel="name"
                      filter
                      filterBy="name"
                      options={[{ id: 0, name: 'Trạng thái cấp phát' }, ...trangThaiCapPhats]}
                    />
                  </div>
                  <div className="flex">
                    <Dropdown
                      className="mr-2 mb-2 w-full"
                      value={selectedGioiTinh}
                      onChange={(e) => setSelectedGioiTinh(e.value)}
                      optionValue="id"
                      optionLabel="name"
                      filter
                      filterBy="name"
                      options={[{ id: 0, name: 'Giới tính' }, ...gioiTinh]}
                    />
                  </div>
                  <div className="flex">
                    <Dropdown
                      className="mr-2 w-full"
                      value={selectedTruong}
                      onChange={(e) => setSelectedTruong(e.value)}
                      optionValue="id"
                      optionLabel="name"
                      filter
                      filterBy="name"
                      options={[{ id: 0, name: 'Trường' }, ...truong]}
                    />
                  </div>
                </div>
              </div>
            }
          />
          <Table
            lazy
            data={datas}
            column={columnTable}
            header={tableHeader}
            {...paging}
            setPaging={pagingChange}
          />
        </div>
      </div>
    </>
  )
}

export default withRouter(ChungNhanTotNghiepTamThoi)
